import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    theme = 'noir';

    layoutMode = 'static';

    megaMenuMode = 'gradient';

    menuMode = 'light';

    profileMode = 'inline';

    inputStyle = 'outlined';

    ripple: boolean;

    showNewMapWizard = false;

    constructor(
        private readonly translateService: TranslateService,
        private primengConfig: PrimeNGConfig) {
    }

    ngOnInit() {
        this.translateService.get('primeng').subscribe(res => this.primengConfig.setTranslation(res));
        this.primengConfig.ripple = true;
        this.ripple = true;
    }
}
